import type { ReactNode } from 'react';
import { cn } from './cn';

export type AlertVariant = 'info' | 'destructive' | 'success';

export interface AlertProps {
  variant?: AlertVariant;
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
}

const variants: Record<AlertVariant, string> = {
  info: 'border-[#3D3328]/15 bg-[#FAF8F5] text-[#3D3328]',
  destructive: 'border-rose-300/40 bg-rose-50 text-rose-800',
  success: 'border-emerald-300/40 bg-emerald-50 text-emerald-800',
};

export function Alert({ variant = 'info', title, children, className }: AlertProps) {
  return (
    <div
      role="alert"
      className={cn('rounded-xl border px-4 py-3 text-sm', variants[variant], className)}
    >
      {title ? <div className="font-semibold mb-1">{title}</div> : null}
      {children ? <div className="text-sm leading-5">{children}</div> : null}
    </div>
  );
}
